import { IConfig } from '../types';

const env = process.env.NODE_ENV;

const getIsUPC = () => {
  const isLocalUPC =
    env === 'development' && process.env.REACT_APP_ENV === 'upc';
  return window.location.pathname.substring(1, 4) === 'upc' || isLocalUPC;
};

const getCountryCode = () => {
  const isLatam = getIsUPC()
    ? window.location.pathname.substring(5, 7) === 'of'
    : window.location.pathname.substring(1, 3) === 'of';

  if (env === 'development') {
    return 'us';
  } else if (isLatam) {
    return 'ofertas';
  }

  return getIsUPC()
    ? window.location.pathname.substring(5, 7)
    : window.location.pathname.substring(1, 3);
};

const getLang = () => document.documentElement.getAttribute('lang');

const getProdImageDirectory = (isUPC: boolean) => {
  const assetPath = `https://${window.location.host}/on/demandware.static/-/Sites-masterCatalog/default/${process.env.REACT_APP_HTML_PATH}/`;
  return assetPath;
};

const CONFIG: IConfig = {
  isUPC: getIsUPC(),
  countryCode: getCountryCode(),
  lang: getLang(),
  assetDirectory: getProdImageDirectory(getIsUPC())
};
export default CONFIG;
